import React, { useMemo } from 'react';
import {
  ReferenceArrayInput,
  required,
  RadioButtonGroupInput,
  FormDataConsumer,
  showNotification,
  Loading
} from 'react-admin';
import { FormSpy } from 'react-final-form';
import { connect } from 'react-redux';

import ResourceUploadApi from '../../../core/apis/ResourceUploadApi';
import DoubleListArrayInput from '../../../core/components/inputs/DoubleListArrayInput';
import { getIcError } from '../../../core/providers/utils';
import dataProvider from '../../../core/providers/IccUserDataProvider';
import Dialog from '@material-ui/core/Dialog';
import DialogTitleWithCloseButton from '../../../core/components/DialogTitleWithCloseButton';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Confirm from '../../../core/components/forked/layout/Confirm';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import FileInput from '../../../core/components/forked/input/FileInput';
import FileField from '../../../core/components/forked/field/FileField';
import { ExcelIcon } from '../../../core/themes/icons/ExcelIcon';
import CloseIcon from '@material-ui/icons/Close';
import { saveAs } from 'file-saver';

import TableSortLabel from '@material-ui/core/TableSortLabel';
import CustomSimpleForm from '../../../core/components/form/CustomSimpleForm';

const validateInvestors = (value, _allValues, _props, _field) => {
  if (value && value.length < 1) {
    return 'At least one Investor must be selected';
  }
  return undefined;
};

const styles = () => ({
  paperWidthFalse: {
    height: 'inherit',
    width: '100%'
  },
  tableWrapper: {
    maxHeight: '70vh',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    /* Track */
    '&::-webkit-scrollbar-track': {
      background: '#ebebeb',
      borderRadius: '10px',
      margin: '2px'
    },
    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: '#9E9E9E',
      borderRadius: '10px'
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#7b7a7a'
    }
  },
  table: {
    overflow: 'auto',
    maxHeight: 'calc(100vh - 364px)',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    /* Track */
    '&::-webkit-scrollbar-track': {
      background: '#ebebeb',
      borderRadius: '10px',
      margin: '2px'
    },
    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: '#9E9E9E',
      borderRadius: '10px'
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#7b7a7a'
    }
  },
  tableContainer: {
    borderTop: '0px'
  },
  labelItems: {
    marginLeft: '3px'
  },
  errorsLabel: {
    color: 'red',
    float: 'right'
  },
  validationColumn: {
    color: 'red'
  },
  containerClass: {
    overflow: 'auto'
  },
  radioGroupRow: {
    marginTop: 0,
    marginBottom: 6
  },
  templateButton: {
    marginLeft: '4%',
    marginTop: '1.7%'
  },
  inputField: {
    width: '48%'
  },
  templateSpan: {
    color: '#2962FF',
    paddingLeft: '4px',
    fontSize: '15px'
  }
});

const StyledFileInput = withStyles({
  dropZone: {
    background: '#ffffff',
    border: '1px dashed #E0E0E0'
  },
  removeButton: {
    textAlign: 'center',
    padding: '.5rem'
  }
})(FileInput);

const sortByValidationError = (a, b) => {
  var x = a['validationError']
    ? a['validationError'].toString().toLowerCase()
    : '';
  var y = b['validationError']
    ? b['validationError'].toString().toLowerCase()
    : '';

  if (x > y) return -1;
  return x < y ? 1 : 0;
};

const DoubleListArrayInputChoicesFiltered = ({
  stepReadOnly,
  fundIdsToFilterBy,
  ...props
}) => {
  const choicesFiltered = useMemo(() => {
    return props.choices.filter(item =>
      fundIdsToFilterBy.includes(item.fundId)
    );
  }, [fundIdsToFilterBy, props.choices]);

  return (
    <DoubleListArrayInput
      {...props}
      optionValue={fundinvestor =>
        fundinvestor.fundId + ':' + fundinvestor.investorId
      }
      optionText="investorName"
      groupBy="fundId"
      groups={fundInvestor => fundInvestor.fundName}
      readOnly={stepReadOnly}
      choices={choicesFiltered}
    />
  );
};

class InvestorsStep extends React.Component {
  formApi;
  pristine;

  state = {};

  componentDidMount() {
    this.getAssignedInvestors();

    dataProvider('GET_LIST', 'investortags', {
      paginated: false,
      filter: {
        orderBy: 'name',
        orderDirection: 'ASC'
      }
    })
      .then(({ data }) => {
        if (data) {
          this.setState({
            tagsList: data
          });
        }
      })
      .catch(error => console.error('Error fetching investor tags :', error));

    if (this.props.resourceupload.fundInvestorTagId == null) {
      dataProvider('GET_LIST', 'fundinvestortags', {
        paginated: false,
        filter: {
          orderBy: 'name',
          orderDirection: 'ASC'
        }
      })
        .then(({ data }) => {
          if (data) {
            this.setState({
              fundInvTagsList: data
            });
          }
        })
        .catch(error =>
          console.error('Error fetching Fund-Investor tags :', error)
        );
    }

    if (this.props.resourceupload.fundInvestorTagId) {
      dataProvider('GET_ONE', 'fundinvestortags', {
        id: this.props.resourceupload.fundInvestorTagId
      })
        .then(({ data }) => {
          if (data) {
            this.setState({
              fundInvestorTag: data
            });
          }
        })
        .catch(error =>
          console.error('Error Fetching Fund-Investor tag: ', error)
        );
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      tagsList: [],
      fundInvTagsList: [],
      investorSelection: false,
      excelDialog: false,
      confirmDialog: false,
      excelTitle: '',
      disabledImport: true,
      fundInvestors: [],
      responseLoading: false,
      response: [],
      hasErrors: false,
      numberOfErrors: 0,
      order: 'desc',
      orderBy: 'Row'
    };
  }

  toggleInvestorSelection(value) {
    this.setState({ investorSelection: value });
  }

  toggleExcelDialog = async (value, showNotification) => {
    //calling the API to populate grid:
    const fundIds = this.props.resourceupload.fundIds;

    if (value) {
      this.setState({ responseLoading: true });
      await ResourceUploadApi.fundInvestorValidateImport(fundIds, value)
        .then(response => {
          this.setState({ responseLoading: false });
          this.setState({ excelDialog: true });

          //we want to automatically sort records with validationErrors to be on top
          var sortedTableData = response.sort(sortByValidationError);

          this.setState({ response: sortedTableData });
        })
        .catch(error => {
          this.setState({ hasErrors: true });
          this.setState({ responseLoading: false });
          this.setState({ disabledImport: true });
          showNotification('ra.notification.server', 'error', {
            messageArgs: { message: getIcError(error) }
          });
        });
    }

    if (value && value.name) {
      this.setState({ excelTitle: value.name });
    }

    const response = this.state.response;
    const numberOfErrors = response.filter(function(item) {
      return item.validationError !== '';
    });
    numberOfErrors.length > 0
      ? this.setState({ disabledImport: true })
      : this.setState({ disabledImport: false });

    this.setState({ numberOfErrors: numberOfErrors.length });
  };

  handleCloseClick = () => {
    this.setConfirmDialogIsOpen(true);
  };

  setConfirmDialogIsOpen(value) {
    this.setState({ confirmDialog: value });
  }

  handleConfirmDialogClose = () => {
    this.setState({ confirmDialog: false });
    this.setState({ excelDialog: false });
    this.setState({ investorSelection: false });
    this.formApi.change('checkBoxChoice', 'STANDARD');
  };

  handleRequestSort = index => {
    const isDesc = this.state.order === 'desc';
    isDesc ? this.setState({ order: 'asc' }) : this.setState({ order: 'desc' });
    this.setState({ orderBy: index });

    var sortColumnName;
    switch (index) {
      case 0:
        sortColumnName = 'rowIndex';
        break;
      case 1:
        sortColumnName = 'fundId';
        break;
      case 2:
        sortColumnName = 'fundName';
        break;
      case 3:
        sortColumnName = 'investorId';
        break;
      case 4:
        sortColumnName = 'investorName';
        break;
      case 5:
        sortColumnName = 'validationError';
        break;
      default:
        sortColumnName = 'rowIndex';
    }

    const tableData = this.state.response.slice(0);
    var sortedTableData = tableData.sort(function(a, b) {
      var x = a[sortColumnName]
        ? a[sortColumnName].toString().toLowerCase()
        : '';
      var y = b[sortColumnName]
        ? b[sortColumnName].toString().toLowerCase()
        : '';
      if (isDesc) {
        if (x < y) return -1;
        return x > y ? 1 : 0;
      } else {
        if (x < y) return 1;
        return x > y ? -1 : 0;
      }
    });

    this.setState({ response: sortedTableData });
  };

  /**
   * List of Fund/Investors read from Excel.
   * Update the metadata.fundinvestors value in form data.
   */
  importFundInvestorsFromExcel = () => {
    this.handleConfirmDialogClose();

    if (!this.state.hasErrors) {
      // Fund/Investor combinations from Excel
      const importedFromExcel = this.state.response;

      // Change input value in form data : array of <fundId>:<investorId
      const assignedFundinvestors = importedFromExcel.map(
        resourcefundinvestor =>
          resourcefundinvestor.fundId + ':' + resourcefundinvestor.investorId
      );
      this.formApi.change('metadata.fundinvestors', assignedFundinvestors);
    }
  };

  render() {
    const {
      onFormInit,
      resourceupload,
      resource,
      formName,
      classes,
      showNotification
    } = this.props;

    const { missingAssignedFunds } = this.state;
    //for batches uploaded via API disabled Investors Step
    const stepReadOnly = !!(
      resourceupload.uploadVia && resourceupload.uploadVia === 'API'
    );

    const radioGroupOptions = {
      row: true,
      classes: {
        row: classes.radioGroupRow
      }
    };

    const handleDownloadClick = async () => {
      ResourceUploadApi.downloadDocumentUploadImportTemplate().then(resp => {
        const fileName = 'Document Upload Import Template.xlsx';
        saveAs(resp, fileName);
      });
    };

    return (
      <CustomSimpleForm
        form={formName}
        save={this.setInvestors}
        toolbar={null}
        resource={resource}
        initialValues={{
          metadata: {
            fundinvestors: []
          },
          checkBoxChoice: 'STANDARD'
        }}
        variant="standard"
        margin="normal"
      >
        <FormSpy subscription={{ pristine: true }}>
          {formprops => {
            // Store current form API object
            if (this.formApi === undefined && onFormInit !== undefined) {
              onFormInit(formprops.form);
            }
            this.formApi = formprops.form;
            this.pristine = formprops.pristine;

            const limitToCall = 200;
            const paramThresholdNotExceeded =
              resourceupload &&
              resourceupload.fundIds.concat(missingAssignedFunds).length <=
                limitToCall;

            const fitId = resourceupload.fundInvestorTagId;
            const customFilter = fitId
              ? {
                  fundId: resourceupload && `[${resourceupload.fundIds[0]}]`,
                  investorStatus: 'ACTIVE',
                  returnInvestorTags: 'true',
                  fundInvestorTagId: fitId,
                  returnFundInvestorTags: 'false'
                }
              : paramThresholdNotExceeded
              ? {
                  fundId:
                    resourceupload &&
                    `[${resourceupload.fundIds.concat(missingAssignedFunds)}]`,
                  investorStatus: 'ACTIVE',
                  returnInvestorTags: 'true',
                  returnFundInvestorTags: 'true'
                }
              : {
                  investorStatus: 'ACTIVE',
                  returnInvestorTags: 'true',
                  returnFundInvestorTags: 'true'
                };

            if (!missingAssignedFunds) return null;

            return (
              <React.Fragment>
                <RadioButtonGroupInput
                  source="checkBoxChoice"
                  label=""
                  options={radioGroupOptions}
                  margin="none"
                  choices={[
                    { id: 'STANDARD', name: 'Available Investors' },
                    { id: 'FILE', name: 'Import Investors from Excel file' }
                  ]}
                  variant="standard"
                  helperText={false}
                  onChange={value => {
                    this.toggleInvestorSelection(value === 'FILE');
                  }}
                />
                {this.state.investorSelection && (
                  <div>
                    <FormDataConsumer>
                      {({ _formData }) => (
                        <div>
                          <StyledFileInput
                            source="file"
                            label="Import File"
                            accept={
                              'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                            }
                            placeholder="Drag and drop File Here or Upload"
                            resource={this.props.resource}
                            variant="standard"
                            onChange={value => {
                              this.toggleExcelDialog(value, showNotification);
                            }}
                            className={classes.inputField}
                            setIsNextAvailable={false}
                          >
                            <FileField
                              source="src"
                              title="title"
                              size="size"
                              type="type"
                            />
                          </StyledFileInput>
                          <Button
                            className={classes.templateButton}
                            onClick={handleDownloadClick}
                          >
                            <ExcelIcon />
                            <span className={classes.templateSpan}>
                              Download Excel Template
                            </span>
                          </Button>
                        </div>
                      )}
                    </FormDataConsumer>
                  </div>
                )}
                {!this.state.investorSelection && (
                  <ReferenceArrayInput
                    label="Investors"
                    resource={resource}
                    reference="fundinvestors"
                    source="metadata.fundinvestors"
                    sort={{ field: 'investorName', order: 'ASC' }}
                    perPage={-1}
                    filter={customFilter}
                    validate={[validateInvestors, required()]}
                  >
                    {paramThresholdNotExceeded ? (
                      <DoubleListArrayInput
                        optionValue={fundinvestor =>
                          fundinvestor.fundId + ':' + fundinvestor.investorId
                        }
                        optionText="investorName"
                        groupBy="fundId"
                        groups={fundInvestor => fundInvestor.fundName}
                        readOnly={stepReadOnly}
                        classes={{
                          containerClass: classes.containerClass
                        }}
                        allowTagFilter={true}
                        tagsList={this.state.tagsList}
                        fundInvTagsList={this.state.fundInvTagsList}
                        source={'investortags'}
                        fundInvestorTag={this.state.fundInvestorTag}
                      />
                    ) : (
                      <DoubleListArrayInputChoicesFiltered
                        fundIdsToFilterBy={resourceupload.fundIds.concat(
                          missingAssignedFunds
                        )}
                        stepReadOnly={stepReadOnly}
                        classes={{
                          containerClass: classes.containerClass
                        }}
                        allowTagFilter={true}
                        tagsList={this.state.tagsList}
                        fundInvTagsList={this.state.fundInvTagsList}
                        source={'investortags'}
                      />
                    )}
                  </ReferenceArrayInput>
                )}
                {this.state.responseLoading ? (
                  <div>
                    <Loading />
                  </div>
                ) : (
                  <div></div>
                )}

                <Dialog
                  open={this.state.excelDialog}
                  aria-label="Import Investors from Excel"
                  maxWidth={false}
                  onClose={(_event, reason) => {
                    if (reason === 'backdropClick') return null;
                    if (reason === 'escapeKeyDown')
                      return this.handleCloseClick();
                  }}
                  classes={{
                    paperWidthFalse: classes.paperWidthFalse // class name, e.g. `classes-nesting-root-x`
                  }}
                >
                  <DialogTitleWithCloseButton onClose={this.handleCloseClick}>
                    Import Investors from Excel
                  </DialogTitleWithCloseButton>
                  <DialogContent>
                    <div>
                      <div>
                        <span>File *</span> <br />
                        <span>
                          <ExcelIcon />
                          <span className={classes.labelItems}>
                            {this.state.excelTitle}
                          </span>
                          <span className={classes.labelItems}>
                            <Button onClick={this.handleConfirmDialogClose}>
                              <CloseIcon />
                            </Button>
                          </span>
                        </span>
                        {this.state.numberOfErrors > 0 && (
                          <span className={classes.errorsLabel}>
                            {this.state.numberOfErrors} errors found. Please fix
                            the Excel file, and upload it again.
                          </span>
                        )}
                        <div className={classes.tableWrapper}>
                          <Table
                            stickyHeader
                            aria-label="sticky table"
                            size="small"
                            className={classes.table}
                          >
                            <TableHead>
                              <TableRow>
                                {[
                                  { id: 'Row Number' },
                                  { id: 'Fund ID' },
                                  { id: 'Fund Name' },
                                  { id: 'Investor ID' },
                                  { id: 'Investor Name' },
                                  { id: 'Validation Error' }
                                ].map((headCell, index) => (
                                  <TableCell
                                    className={classes.cell}
                                    key={headCell.id}
                                    sortDirection={
                                      this.state.orderBy === index
                                        ? this.state.order
                                        : false
                                    }
                                  >
                                    <TableSortLabel
                                      active={this.state.orderBy === index}
                                      direction={this.state.order}
                                      onClick={() =>
                                        this.handleRequestSort(index)
                                      }
                                    >
                                      {headCell.id}
                                    </TableSortLabel>
                                  </TableCell>
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.response &&
                                this.state.response.map((item, index) => {
                                  return (
                                    <TableRow key={index} hover>
                                      <TableCell>{item.rowIndex}</TableCell>
                                      <TableCell>{item.fundId}</TableCell>
                                      <TableCell>{item.fundName}</TableCell>
                                      <TableCell>{item.investorId}</TableCell>
                                      <TableCell>{item.investorName}</TableCell>
                                      <TableCell
                                        className={classes.validationColumn}
                                      >
                                        {item.validationError}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                            </TableBody>
                          </Table>
                        </div>
                      </div>
                    </div>
                    {this.state.confirmDialog && (
                      <Confirm
                        isOpen={this.state.confirmDialog}
                        title="Close Window?"
                        content={
                          <div>
                            <p style={{ margin: 0 }}>
                              You are about to quit importing Investors, and
                              return to Select Investors page.
                            </p>
                            <br />
                            Your progress on this step will not be saved.
                          </div>
                        }
                        onConfirm={this.handleConfirmDialogClose}
                        onClose={this.handleConfirmDialogClose}
                        confirm="ra.action.close"
                      />
                    )}
                  </DialogContent>
                  <DialogActions
                    style={{ borderTop: `1px solid rgba(0, 0, 0, 0.12)` }}
                  >
                    <Button
                      onClick={this.handleConfirmDialogClose}
                      color="primary"
                      variant="outlined"
                      className={classes.button}
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={() => this.importFundInvestorsFromExcel()}
                      color="primary"
                      variant="contained"
                      className={classes.button}
                      disabled={this.state.disabledImport}
                    >
                      Import
                    </Button>
                  </DialogActions>
                </Dialog>
              </React.Fragment>
            );
          }}
        </FormSpy>
      </CustomSimpleForm>
    );
  }

  getAssignedInvestors = async () => {
    const { resourceupload, showNotification } = this.props;
    const { resourceUploadId } = resourceupload;

    let resourcefundinvestors = [];
    try {
      // Call v1/resourcefundinvestors?resourceUploadId=${resourceUploadId}
      const resourceFundInvestorsObject = await ResourceUploadApi.getFundinvestors(
        resourceUploadId
      );
      if (resourceFundInvestorsObject) {
        resourcefundinvestors = resourceFundInvestorsObject.pageData;
      }
    } catch (error) {
      showNotification('ra.notification.server', 'error', {
        messageArgs: { message: getIcError(error) }
      });
    }

    const assignedFundinvestors = resourcefundinvestors.map(
      resourcefundinvestor => {
        return (
          resourcefundinvestor.fundId + ':' + resourcefundinvestor.investorId
        );
      }
    );

    const missingAssignedFunds = resourcefundinvestors
      .filter(res => !resourceupload.fundIds.includes(res.fundId))
      .map(resourcefundinvestor => resourcefundinvestor.fundId);

    this.formApi.change('metadata.fundinvestors', assignedFundinvestors);

    this.setState(() => {
      return {
        missingAssignedFunds, // Using this to add missing assigned funds to DoubleListArrayInput
        assignedFundinvestors // Only to compare between the old list of fundinvestors and the new one so we can DELETE the unselected ones
      };
    });
  };

  /**
   * Link resourceupload to investors
   */
  setInvestors = async values => {
    const { assignedFundinvestors = [] } = this.state;
    const {
      resourceupload,
      onSubmitEnd,
      handleResetActionButtons,
      disableActionButtons,
      showNotification
    } = this.props;
    const { resourceUploadId } = resourceupload;
    const { fundinvestors } = values.metadata; // List of fundinvestors. Ex : ["F1:I1", "F1:I2", "F2:I1"]
    disableActionButtons();
    const fundinvestorsToDelete = assignedFundinvestors.filter(
      x => !fundinvestors.includes(x)
    );
    if (fundinvestorsToDelete.length !== 0) {
      const deleteRequestBody = fundinvestorsToDelete.map(fundinvestor => {
        const [fundId, investorId] = fundinvestor.split(':');
        return { resourceUploadId, fundId, investorId };
      });
      try {
        await ResourceUploadApi.deleteFundinvestors(deleteRequestBody);
      } catch (error) {
        handleResetActionButtons();
        showNotification('ra.notification.server', 'error', {
          messageArgs: { message: getIcError(error) }
        });
      }
    }

    // Request body : create one row for each fund/investor
    const body = fundinvestors.map(fundinvestor => {
      const [fundId, investorId] = fundinvestor.split(':');
      return { resourceUploadId, fundId, investorId };
    });

    try {
      await ResourceUploadApi.setFundinvestors(body);
      if (onSubmitEnd) {
        onSubmitEnd(resourceupload);
      }
    } catch (error) {
      handleResetActionButtons();
      showNotification('ra.notification.server', 'error', {
        messageArgs: { message: getIcError(error) }
      });
    }
  };
}

const mapDispatchToProps = {
  showNotification
};
export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(InvestorsStep));
